import { Component, OnInit, Input } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { PackageDataService } from '../../data-services/package.service';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { RequisitionDataService } from '../../data-services/requisition.service';
import { UserDataService } from '../../data-services/user.service';
import { AccordionModule } from 'primeng/accordion';
import { FormsModule } from '@angular/forms';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { ReceivingSampleComponent } from '../receiving-list/receiving.sample';
import { IntervennSampleReceiveComponent } from './intervenn.sample.receive';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'intervenn-samples',
  templateUrl: './intervenn.receiving.samples.html',
  styleUrls: ["./intervenn.receiving.samples.css"],
  providers: [MessageService],
  imports: [TableModule, FormsModule, Toast, CommonModule, SelectModule, ReceivingSampleComponent, IntervennSampleReceiveComponent]
})
export class IntervennReceivingSamples implements OnInit {

  constructor(private packageDataService: PackageDataService,
    private messageService: MessageService,
    private requisitionService: RequisitionDataService,
    private userService: UserDataService,
    private _clipboardService: ClipboardService) {
  }

  loading: boolean = false;
  processingExceptions: boolean = false;
  package: any = {};
  requisitions: any[];
  resolveUsers: SelectItem[];
  reqCount: number = 0;
  reqCountRejected: number = 0;
  reqCountException: number = 0;
  cols: any[];
  totalRecords: number;

  ngOnInit() {
    this.loading = true;

    this.cols = [
      { field: 'Accession', header: 'Accession' },
      { field: 'PatientName', header: 'Patient Name' },
      { field: 'BirthDate', header: 'DOB' },
      { field: 'DateOfService', header: 'Collection Date' },
      { field: 'DateReceived', header: 'Received Date' },
      { field: 'Status', header: 'Status' },
      { field: 'StatusDate', header: 'Status Date' },
   ];
  }

  searchTerm: string = "";
  public handleSearchKey(event, reqlist) {
    if (event.keyCode == 13) {
      reqlist.filterGlobal(event.target.value, 'contains');
      this.searchTerm = event.target.value;
      event.preventDefault();
    }
  }

  lastLoad: LazyLoadEvent;
  public loadPackagesLazy(event: LazyLoadEvent) {
    console.log("load requisitions");
    if (this.searchTerm != undefined && this.searchTerm.length > 0 && event.filters.global == undefined) {
      return;
    }

    this.loading = true;

    if (event) {
      this.lastLoad = event;
    } else {
      this.lastLoad.first = 0;
      event = this.lastLoad;
    }
    this.requisitionService.getList(event.first, event.rows, event.sortField, event.sortOrder, this.getFilters()).subscribe((data: any) => {
      console.log("samples", data);
      this.totalRecords = data.totalRows;
      this.requisitions = data.rows;

      for (var i = 0; i < this.requisitions.length; i++) {
        if (this.requisitions[i].FirstName && this.requisitions[i].LastName) {
          this.requisitions[i].PatientName = this.requisitions[i].FirstName + " " + this.requisitions[i].LastName;
        }
      }

      if (this.requisitions.length == 1) {
        this.requisitions[0].showDetail = true;
      }
      else {
        for (var i = 0; i < this.requisitions.length; i++) {
          this.requisitions[i].showDetail = false;
        }
      }
      event.filters.global = {};
      this.loading = false;
    });

  }

  public getFilters() {
    var filters: any[] = [];
    if (this.searchTerm.length > 0) {
      filters.push({ field: 'global', header: 'global', filter: this.searchTerm });
    }

    return JSON.stringify(filters);
  }


  public sampleDisplayed(requisitionId) {
  }

  public copyToClipBoard(type) {
    if (!this.requisitions) {
      this.messageService.add({ severity: 'error', summary: 'Clipboard copy - nothing to copy', detail: 'There are no samples in the package ' });
    }
    var copyText = "";
    var getClipboardText = function (val) {
      var dob = val.BirthDate ? new Date(val.BirthDate).toLocaleDateString() : "";
      return val.Accession +
        ((val.FirstName || val.LastName) ? " - " : "") +
        [val.FirstName, val.LastName] +
        (val.BirthDate ? " - " : "") +
        [dob];
    };

    if (type == "A") {
      this.requisitions.forEach(function (val) {

        copyText += getClipboardText(val) + " \r\n";
      });
    } else if (type == "E") {
      this.requisitions.filter(x => x.IsRejected == false && x.HasExceptions).forEach(function (val) {
        copyText += getClipboardText(val) + " \r\n";
      });
    } else if (type == "R") {
      this.requisitions.filter(x => x.IsRejected).forEach(function (val) {
        copyText += getClipboardText(val) + " \r\n";
      });
    }

    this._clipboardService.copy(copyText);
    this.messageService.add({ severity: 'success', summary: 'Package Exceptions', detail: 'copied to clipboard' });
  }

}
